import { DataFieldConfig, forEstateTypes } from './data-builder';
import { ICONS } from '~/constants/icons';
import { getElectricityConsumption, getOperationCost } from '@habity/services';
import { formatCurrency } from '@habity/utils';

export const operatingCostsFields: DataFieldConfig[] = [
  {
    key: 'operation.sum',
    label: 'Totalt',
    icon: ICONS.OPERATING_COSTS.SUM,
    formatter: (value) => `${getOperationCost(value, true)} (${getOperationCost(value, false)})`,
    condition: (context) => {
      const value = context.filteredProviderData?.operation?.sum;
      return value && value > 0;
    },
  },
  {
    key: 'operation.heating',
    label: 'Uppvärmning',
    icon: ICONS.OPERATING_COSTS.HEATING,
    formatter: (value) => `${getOperationCost(value, true)} (${getOperationCost(value, false)})`,
    condition: (context) => {
      const value = context.filteredProviderData?.operation?.heating;
      return value && value > 0;
    },
  },
  {
    key: 'operation.electricity',
    label: 'El',
    icon: ICONS.OPERATING_COSTS.ELECTRICITY,
    formatter: (value) => `${getOperationCost(value, true)} (${getOperationCost(value, false)})`,
    condition: (context) => {
      const value = context.filteredProviderData?.operation?.electricity;
      return value && value > 0;
    },
  },
  {
    key: 'operation.waterAndDrain',
    label: 'Vatten och avlopp',
    icon: ICONS.OPERATING_COSTS.WATER,
    formatter: (value) => `${getOperationCost(value, true)} (${getOperationCost(value, false)})`,
    condition: (context) => {
      const value = context.filteredProviderData?.operation?.waterAndDrain;
      return value && value > 0;
    },
  },
  {
    key: 'operation.chimneySweeping',
    label: 'Sotning',
    icon: ICONS.OPERATING_COSTS.CHIMNEY,
    formatter: (value) => `${getOperationCost(value, true)} (${getOperationCost(value, false)})`,
    condition: (context) => {
      const value = context.filteredProviderData?.operation?.chimneySweeping;
      return value && value > 0;
    },
  },
  {
    key: 'operation.roadCommunity',
    label: 'Väg och samfällighet',
    icon: ICONS.OPERATING_COSTS.ROAD,
    formatter: (value) => `${getOperationCost(value, true)} (${getOperationCost(value, false)})`,
    condition: (context) => {
      const value = context.filteredProviderData?.operation?.roadCommunity;
      return value && value > 0;
    },
  },
  {
    key: 'operation.sanitation',
    label: 'Renhållning',
    icon: ICONS.OPERATING_COSTS.SANITATION,
    formatter: (value) => `${getOperationCost(value, true)} (${getOperationCost(value, false)})`,
    condition: (context) => {
      const value = context.filteredProviderData?.operation?.sanitation;
      return value && value > 0;
    },
  },
  {
    key: 'operation.insurance',
    label: 'Försäkring',
    icon: ICONS.OPERATING_COSTS.INSURANCE,
    formatter: (value) => `${getOperationCost(value, true)} (${getOperationCost(value, false)})`,
    condition: (context) => {
      const value = context.filteredProviderData?.operation?.insurance;
      return value && value > 0;
    },
  },
  {
    key: 'insurance.fullValue',
    label: 'Fullvärde',
    icon: ICONS.OPERATING_COSTS.INSURANCE_FULL_VALUE,
    formatter: (value) => value ? 'Ja' : 'Nej',
    source: 'provider',
    estateTypes: forEstateTypes('House', 'Cottage', 'Farm', 'CommercialProperty'),
    condition: (context) => {
      const insurance = context.filteredProviderData?.operation?.insurance;
      const fullValue = context.filteredProviderData?.insurance?.fullValue;
      return insurance && insurance > 0 && fullValue !== undefined && fullValue !== null;
    },
  },
  {
    key: 'operation.roadCharge',
    label: 'Vägavgift',
    icon: ICONS.OPERATING_COSTS.ROAD,
    formatter: (value) => `${getOperationCost(value, true)} (${getOperationCost(value, false)})`,
    condition: (context) => {
      const value = context.filteredProviderData?.operation?.roadCharge;
      return value && value > 0;
    },
  },
  {
    key: 'operation.maintenance',
    label: 'Underhåll',
    icon: ICONS.OPERATING_COSTS.MAINTENANCE,
    formatter: (value) => `${getOperationCost(value, true)} (${getOperationCost(value, false)})`,
    condition: (context) => {
      const value = context.filteredProviderData?.operation?.maintenance;
      return value && value > 0;
    },
  },
  {
    key: 'operation.other',
    label: 'Övrigt',
    icon: ICONS.OPERATING_COSTS.OTHER,
    formatter: (value) => `${getOperationCost(value, true)} (${getOperationCost(value, false)})`,
    condition: (context) => {
      const value = context.filteredProviderData?.operation?.other;
      return value && value > 0;
    },
  },
  {
    key: 'electricity.companie',
    label: 'Nätbolag',
    icon: ICONS.OPERATING_COSTS.ELECTRICITY,
    estateTypes: forEstateTypes('House', 'Cottage', 'HousingCooperative'),
  },
    {
    key: 'electricity.distributor',
    label: 'Elleverantör',
    icon: ICONS.OPERATING_COSTS.ELECTRICITY,
    estateTypes: forEstateTypes('House', 'Cottage', 'HousingCooperative'),
  },
  {
    key: 'electricity.powerConsumptionKWH',
    label: 'Elförbrukning',
    icon: ICONS.OPERATING_COSTS.ELECTRICITY_CONSUMPTION,
    formatter: (value) => getElectricityConsumption(value),
    condition: (context) => {
      const value = context.filteredProviderData?.electricity?.powerConsumptionKWH;
      return value && value > 0;
    },
  },
  {
    key: 'operation.personsInTheHousehold',
    label: 'Beräknat på',
    icon: ICONS.OPERATING_COSTS.PEOPLE,
    formatter: (value) => value + ' personer i hushållet',
    condition: (context) => {
      const value = context.filteredProviderData?.operation?.personsInTheHousehold;
      return value && value > 0;
    },
  },




  // For farm estates

    {
    key: 'mainResidentialBuilding.operation.sum',
    label: 'Totalt',
    icon: ICONS.OPERATING_COSTS.SUM,
    formatter: (value) => `${getOperationCost(value, true)} (${getOperationCost(value, false)})`,
    estateTypes: forEstateTypes('Farm'),
    condition: (context) => {
      const value = context.filteredProviderData?.mainResidentialBuilding?.operation?.sum;
      return value && value > 0;
    },
  },
  {
    key: 'mainResidentialBuilding.operation.heating',
    label: 'Uppvärmning',
    icon: ICONS.OPERATING_COSTS.HEATING,
    formatter: (value) => `${getOperationCost(value, true)} (${getOperationCost(value, false)})`,
    estateTypes: forEstateTypes('Farm'),
    condition: (context) => {
      const value = context.filteredProviderData?.mainResidentialBuilding?.operation?.heating;
      return value && value > 0;
    },
  },
  {
    key: 'mainResidentialBuilding.operation.electricity',
    label: 'El',
    icon: ICONS.OPERATING_COSTS.ELECTRICITY,
    formatter: (value) => `${getOperationCost(value, true)} (${getOperationCost(value, false)})`,
    estateTypes: forEstateTypes('Farm'),
    condition: (context) => {
      const value = context.filteredProviderData?.mainResidentialBuilding?.operation?.electricity;
      return value && value > 0;
    },
  },
  {
    key: 'mainResidentialBuilding.operation.waterAndDrain',
    label: 'Vatten och avlopp',
    icon: ICONS.OPERATING_COSTS.WATER,
    formatter: (value) => `${getOperationCost(value, true)} (${getOperationCost(value, false)})`,
    estateTypes: forEstateTypes('Farm'),
    condition: (context) => {
      const value = context.filteredProviderData?.mainResidentialBuilding?.operation?.waterAndDrain;
      return value && value > 0;
    },
  },
  {
    key: 'mainResidentialBuilding.operation.chimneySweeping',
    label: 'Sotning',
    icon: ICONS.OPERATING_COSTS.CHIMNEY,
    formatter: (value) => `${getOperationCost(value, true)} (${getOperationCost(value, false)})`,
    estateTypes: forEstateTypes('Farm'),
    condition: (context) => {
      const value = context.filteredProviderData?.mainResidentialBuilding?.operation?.chimneySweeping;
      return value && value > 0;
    },
  },
  {
    key: 'mainResidentialBuilding.operation.roadCommunity',
    label: 'Väg och samfällighet',
    icon: ICONS.OPERATING_COSTS.ROAD,
    formatter: (value) => `${getOperationCost(value, true)} (${getOperationCost(value, false)})`,
    estateTypes: forEstateTypes('Farm'),
    condition: (context) => {
      const value = context.filteredProviderData?.mainResidentialBuilding?.operation?.roadCommunity;
      return value && value > 0;
    },
  },
  {
    key: 'mainResidentialBuilding.operation.sanitation',
    label: 'Sophämtning',
    icon: ICONS.OPERATING_COSTS.SANITATION,
    formatter: (value) => `${getOperationCost(value, true)} (${getOperationCost(value, false)})`,
    estateTypes: forEstateTypes('Farm'),
    condition: (context) => {
      const value = context.filteredProviderData?.mainResidentialBuilding?.operation?.sanitation;
      return value && value > 0;
    },
  },
  {
    key: 'mainResidentialBuilding.operation.insurance',
    label: 'Försäkring',
    icon: ICONS.OPERATING_COSTS.INSURANCE,
    formatter: (value) => `${getOperationCost(value, true)} (${getOperationCost(value, false)})`,
    estateTypes: forEstateTypes('Farm'),
    condition: (context) => {
      const value = context.filteredProviderData?.mainResidentialBuilding?.operation?.insurance;
      return value && value > 0;
    },
  },
  {
    key: 'mainResidentialBuilding.insurance.fullValue',
    label: 'Fullvärde',
    icon: ICONS.OPERATING_COSTS.INSURANCE_FULL_VALUE,
    formatter: (value) => value ? 'Ja' : 'Nej',
    source: 'provider',
    estateTypes: forEstateTypes('Farm'),
    condition: (context) => {
      const insurance = context.filteredProviderData?.mainResidentialBuilding?.operation?.insurance;
      const fullValue = context.filteredProviderData?.mainResidentialBuilding?.insurance?.fullValue;
      return insurance && insurance > 0 && fullValue !== undefined && fullValue !== null;
    },
  },
  {
    key: 'operation.roadCharge',
    label: 'Vägavgift',
    icon: ICONS.OPERATING_COSTS.ROAD,
    formatter: (value) => `${getOperationCost(value, true)} (${getOperationCost(value, false)})`,
    estateTypes: forEstateTypes('Farm'),
    condition: (context) => {
      const value = context.filteredProviderData?.mainResidentialBuilding?.operation?.roadCharge;
      return value && value > 0;
    },
  },
  {
    key: 'mainResidentialBuilding.operation.maintenance',
    label: 'Underhåll',
    icon: ICONS.OPERATING_COSTS.MAINTENANCE,
    formatter: (value) => `${getOperationCost(value, true)} (${getOperationCost(value, false)})`,
    estateTypes: forEstateTypes('Farm'),
    condition: (context) => {
      const value = context.filteredProviderData?.mainResidentialBuilding?.operation?.maintenance;
      return value && value > 0;
    },
  },
  {
    key: 'mainResidentialBuilding.operation.other',
    label: 'Övrigt',
    icon: ICONS.OPERATING_COSTS.OTHER,
    formatter: (value) => `${getOperationCost(value, true)} (${getOperationCost(value, false)})`,
    estateTypes: forEstateTypes('Farm'),
    condition: (context) => {
      const value = context.filteredProviderData?.mainResidentialBuilding?.operation?.other;
      return value && value > 0;
    },
  },
  {
    key: 'mainResidentialBuilding.electricity.companie',
    label: 'Nätbolag',
    icon: ICONS.OPERATING_COSTS.ELECTRICITY,
    estateTypes: forEstateTypes('Farm'),
  },
  {
    key: 'mainResidentialBuilding.electricity.powerConsumptionKWH',
    label: 'Elförbrukning',
    icon: ICONS.OPERATING_COSTS.ELECTRICITY_CONSUMPTION,
    formatter: (value) => getElectricityConsumption(value),
    estateTypes: forEstateTypes('Farm'),
    condition: (context) => {
      const value = context.filteredProviderData?.mainResidentialBuilding?.electricity?.powerConsumptionKWH;
      return value && value > 0;
    },
  },
  {
    key: 'mainResidentialBuilding.operation.personsInTheHousehold',
    label: 'Beräknat på',
    icon: ICONS.OPERATING_COSTS.PEOPLE,
    formatter: (value) => value + ' personer i hushållet',
    estateTypes: forEstateTypes('Farm'),
    condition: (context) => {
      const value = context.filteredProviderData?.mainResidentialBuilding?.operation?.personsInTheHousehold;
      return value && value > 0;
    },
  },

  // For all estate types
  {
    key: 'assess.taxFee',
    label: 'Fastighetsavgift',
    icon: ICONS.OPERATING_COSTS.PROPERTY_TAX,
    condition: (context) => {
      const value = context.filteredProviderData?.assess?.taxFee;
      return value && value > 0;
    },
    formatter: (value) => 'Tillkommer med ' + formatCurrency(value) + ' per år',
    source: 'provider',
  },
  {
    key: 'assess.leasholdFee',
    label: 'Tomträttsavgäld',
    icon: ICONS.OPERATING_COSTS.PROPERTY_TAX,
    condition: (context) => {
      const value = context.provider_data?.assess?.leasholdFee;
      return value > 0;
    },
    source: 'provider',
    formatter: (value) => formatCurrency(value) + ' per år',
  },
  {
    key: 'assess.leasholdUntil',
    label: 'Tomträtt till',
    icon: ICONS.OPERATING_COSTS.PROPERTY_TAX,
    condition: (context) => {
      const value = context.provider_data?.assess?.leasholdUntil;
      return !!value;
    },
    source: 'provider',
    formatter: (value) => {
      if (!value) return '';
      try {
        const date = new Date(value);
        return date.toLocaleDateString('sv-SE', {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        });
      } catch {
        return value;
      }
    },
  },

  // Commentary field - all estate types except farm
  {
    key: 'operation.commentary',
    label: 'Kommentar',
    icon: ICONS.OPERATING_COSTS.COMMENT,
    formatter: (value, context) => {
      const { operation } = context?.filteredProviderData || {};
      const commentary = operation && 'commentary' in operation ? operation.commentary : undefined;
      return commentary || 'Angiven driftkostnad är beräknad enligt schablon. Kostnaden kan bli både högre och lägre för ny boende.';
    },
  },

  // Commentary field - farm estate
  {
    key: 'mainResidentialBuilding.operation.commentary',
    label: 'Kommentar',
    icon: ICONS.OPERATING_COSTS.COMMENT,
    estateTypes: forEstateTypes('Farm'),
    formatter: (value, context) => {
      const { operation } = context?.filteredProviderData?.mainResidentialBuilding || {};
      const commentary = operation && 'commentary' in operation ? operation.commentary : undefined;
      return commentary || 'Angiven driftkostnad är beräknad enligt schablon. Kostnaden kan bli både högre och lägre för ny boende.';
    },
  },
];
